import {
  delay,
  call,
  put,
  takeLatest,
  race,
  select,
  cancelled,
} from "redux-saga/effects";
import {
  addLeadEstimateAction,
  addLeadLogAction,
  addLeadQuoteAction,
  addNewLeadAction,
  deleteLeadAddressAction,
  deleteSingleLeadQuoteAction,
  getAccountNameListAction,
  getAllLeadListAction,
  getAllLeadLogListAction,
  getAllReferrerListAction,
  getCalculateDistanceAction,
  getLeadCustomerAction,
  getLeadEstimateAction,
  getLeadEstimateLinkAction,
  getPreviousQuoteAction,
  getSingleLeadAction,
  setAccountNameListAction,
  setAddLeadLogAction,
  setAddNewLeadAction,
  setAllLeadListAction,
  setAllLeadLogListAction,
  setAllReferrerListAction,
  setCalculateCollectionDistanceAction,
  setCalculateDeliveryDistanceAction,
  setCalculateReturnDistanceAction,
  setDeleteSingleLeadQuoteAction,
  setLeadAddressDeletedAction,
  setLeadCustomerResponse,
  setLeadEstimateAction,
  setLeadEstimateDownloaded,
  setLeadListAction,
  setLeadQuoteAction,
  setPreviousQuoteAction,
  setSingleLeadAction,
  setSingleLeadEstimateAction,
  setUpdateLeadAction,
  setUpdateLeadEstimateResponse,
  setUpdateLeadQuoteResponse,
  updateLeadAction,
} from "../reducers/leadSlice";
import { callAPI, handleError, handleSuccess } from "../api/api";
import { setLoaderAction, setNotificationAction } from "../reducers/mmymSlice";
import JsFileDownloader from "js-file-downloader";
import store from "../store";
import { setLoaderMessage } from "../reducers/clientConfirmationSlice";

let activeLeadListController: AbortController | null = null;
let latestLeadListRequestId = 0;

/**
 * This function for call the user profile
 *
 * @param {*} payload
 */

// const getUserDataFromLocalStorage = () => {
//   const userData = localStorage.getItem('user');
//   return userData ? JSON.parse(userData) : null;
// };

function* getAllLeadSaga(action: {
  type: string;
  payload: {
    page: number;
    limit: number;
    orderBy: string;
    orderIn: string;
    roleType?: string;
    search: string;
    filterStatus: string;
    accountName?: string;
    salesPersonId?: string;
    b2bAccounts?: boolean;
  };
}): any {
  const requestId = ++latestLeadListRequestId;
  const {
    page,
    limit,
    orderBy,
    orderIn,
    roleType,
    search,
    filterStatus,
    accountName,
    salesPersonId,
    b2bAccounts,
  } = action.payload;

  if (activeLeadListController) {
    activeLeadListController.abort();
  }

  const controller = new AbortController();
  activeLeadListController = controller;

  yield put(setLoaderAction(true));

  let filter = "";
  if (filterStatus && filterStatus !== "CURRENT") {
    filter = `&filterStatus=${filterStatus}`;
  }
  if (accountName) {
    filter += `&accountName=${accountName}`;
  }
  if (salesPersonId) {
    filter += `&salesPersonId=${salesPersonId}`;
  }
   if (b2bAccounts) {
    filter += `&b2bAccounts=${b2bAccounts}`;
  }
  try {
    const endpoint =
      roleType === "TENANT" || roleType === "Admin"
        ? `leads?page=${page}&limit=${limit}&orderBy=${orderBy}&orderIn=${orderIn}&search=${search}${filter}`
        : `surveys/leads?page=${page}&limit=${limit}&createdAt=${orderBy}&orderIn=${orderIn}&search=${search}${filter}`;

    const lead = yield call<any>(callAPI, action.payload, "get", endpoint, "", {
      signal: controller.signal,
    });

    if (lead?.data) {
      yield put(setAllLeadListAction(lead?.data));
      yield put(setLeadListAction(true));
    }
  } catch (error: any) {
    if (error?.code === "ERR_CANCELED") {
      return;
    }

    error?.response && handleError(error?.response, [401]);
    yield put(setLeadListAction(false));
    error?.code === "ERR_NETWORK" && handleError(error);
  } finally {
    if (activeLeadListController === controller) {
      activeLeadListController = null;
    }

    if (yield cancelled()) {
      controller.abort();
    }

    if (requestId === latestLeadListRequestId) {
      yield put(setLoaderAction(false));
    }
  }
}

function* getAllReferrerListSaga(action: {
  type: string;
  payload: { page: number; limit: number; orderBy: string; orderIn: string };
}): any {
  const { page, limit, orderBy, orderIn } = action.payload;
  yield put(setLoaderAction(true));

  try {
    const referrer = yield call<any>(
      callAPI,
      action.payload,
      "get",
      `client/all-referrers?page=${page}&limit=${limit}&orderBy=${orderBy}&orderIn=${orderIn}`,
    );

    if (referrer?.data) {
      yield put(setAllReferrerListAction(referrer?.data));
    }
  } catch (error: any) {
    console.log("Catch Error-", error);
    // error?.response && handleError(error?.response?.data)
  }
  yield put(setLoaderAction(false));
}

function* getSingleLeadSaga(action: any): any {
  yield put(setLoaderAction(true));
  try {
    console.log("getSingleLeadSaga action.payload", action.payload);
    const { generateId, role } = action.payload; // Directly access the payload
    let url = "";
    if (role === "customer") {
      url = `customers/leads/${generateId}`;
    } else {
      url = `leads/${action.payload}`;
    }
    const singleLead = yield call<any>(callAPI, {}, "get", url);

    if (singleLead?.data) {
      yield put(setSingleLeadAction(singleLead?.data));
    }
  } catch (error) {
    console.log("Catch Error-", error);
  }
  yield put(setLoaderAction(false));
}

function* addNewLeadSaga(payload: { payload: { packingOn: string } }): any {
  yield put(setLoaderAction(true));
  yield put(setNotificationAction({ message: [], severity: "error" }));
  // Destructure the payload to exclude the `packingOn` field
  const { packingOn, ...newPayload } = payload?.payload;
  try {
    const apiResponse = yield call<any>(
      callAPI,
      { payload: newPayload },
      "post",
      `leads`,
    );

    if (apiResponse?.success === true) {
      apiResponse && handleSuccess(apiResponse);
      // yield put(setAdminSuccessAction(true));
      yield put(setAddNewLeadAction(true));
      yield put(
        getAllLeadListAction({
          page: 1,
          limit: 10,
          orderBy: "created_at",
          orderIn: "DESC",
          search: "",
          roleType: "Admin",
        }),
      );
    }
  } catch (error: any) {
    error?.response && handleError(error?.response);
    error?.code === "ERR_NETWORK" && handleError(error);
    yield put(setAddNewLeadAction(false));
    //   yield put(setAdminErrorAction(true));
  }
  yield put(setLoaderAction(false));
}

function* updateLeadSaga(action: { payload: any }): any {
  yield put(setLoaderAction(true));
  yield put(setNotificationAction({ message: [], severity: "error" }));
  try {
    const { id, ...payload } = action?.payload;

    const apiResponse = yield call<any>(
      callAPI,
      { payload: payload },
      "put",
      `leads/${id}`,
    );

    if (apiResponse?.success === true) {
      apiResponse && handleSuccess(apiResponse);
      yield put(setUpdateLeadAction(true));
    }
  } catch (error: any) {
    error?.response && handleError(error?.response);
    error?.code === "ERR_NETWORK" && handleError(error);
    yield put(setUpdateLeadAction(false));
  }
  yield put(setLoaderAction(false));
}

function* addLeadLogSaga(action: { payload: any }): any {
  yield put(setLoaderAction(true));
  yield put(setNotificationAction({ message: [], severity: "error" }));
  try {
    const { leadId, ...payload } = action?.payload;

    const apiResponse = yield call<any>(
      callAPI,
      { payload: payload },
      "post",
      `leads/${leadId}/audit`,
    );

    if (apiResponse?.success === true) {
      apiResponse && handleSuccess(apiResponse);
      yield put(setAddLeadLogAction(true));
      // yield put(
      //   getAllLeadListAction({
      //     page: 1,
      //     limit: 10,
      //     orderBy: "created_at",
      //     orderIn: "DESC",
      //     search: "",
      //     roleType: "Admin",
      //   })
      // );
    }
  } catch (error: any) {
    error?.response && handleError(error?.response);
    error?.code === "ERR_NETWORK" && handleError(error);
    yield put(setAddLeadLogAction(false));
  }
  yield put(setLoaderAction(false));
}

function* getAllLeadLogListSaga(action: any): any {
  const { page, limit, orderBy, orderIn } = action.payload;
  yield put(setLoaderAction(true));

  try {
    const leadId = action.payload?.leadId;
    const lead = yield call<any>(
      callAPI,
      action.payload,
      "get",
      `leads/${leadId}/audit?page=${page}&limit=${limit}&orderBy=${orderBy}&orderIn=${orderIn}`,
    );

    if (lead?.data) {
      yield put(setAllLeadLogListAction(lead?.data));
    }
  } catch (error: any) {
    console.log("Catch Error-", error);
    // error?.response && handleError(error?.response?.data)
  }
  yield put(setLoaderAction(false));
}

function* getCalculateDistanceSaga(payload: { payload: any }): any {
  yield put(setLoaderAction(true));
  yield put(setNotificationAction({ message: [], severity: "error" }));
  try {
    const { type, ...newPayload } = payload?.payload;

    const apiResponse = yield call<any>(
      callAPI,
      { payload: newPayload },
      "post",
      "leads/distance",
    );

    if (apiResponse?.success === true) {
      // apiResponse && handleSuccess(apiResponse);
      if (type === "collection") {
        yield put(setCalculateCollectionDistanceAction(apiResponse?.data));
      } else if (type === "delivery") {
        yield put(setCalculateDeliveryDistanceAction(apiResponse?.data));
      } else if (type === "return") {
        yield put(setCalculateReturnDistanceAction(apiResponse?.data));
      }
    }
  } catch (error: any) {
    console.log("Catch Error-", error);
    error?.response && handleError(error?.response);
    error?.code === "ERR_NETWORK" && handleError(error);
  }
  yield put(setLoaderAction(false));
}

function* addLeadEstimateSaga(payload: { payload: any }): any {
  yield put(setLoaderAction(true));
  yield put(setNotificationAction({ message: [], severity: "error" }));
  // Destructure the payload to exclude the `packingOn` field

  const { generatedId, screenType } = payload?.payload;
  const {
    leadId,
    createdAt,
    updated_at,
    count,
    pdfs3key,
    bucketname,
    contentValue,
    quoteId,
    ancillaries,
    isDeletable,
    hasFinalInvoice,
    is_reaccept_required,
    subConstractorCharges,
    subcontractorCharges,
    requirements,
    hasRemovalOrDoorToDoor,
    ...body
  } = payload?.payload?.body;

  // Set quoteExpiresOn conditionally
  body.quoteExpiresOn = screenType === "quotation" ? body.quoteExpiresOn : "";

  let services: any = [];
  body?.services?.map((ele: any, idx: any) => {
    if (
      ele?.description &&
      (ele?.price || ele?.price === 0) &&
      (ele?.driverQty == null || ele?.driverQty === 0)
    ) {
      // services.push({
      //   ...ele,
      //   price: Number(ele?.price),
      // })
      const service: any = {
        ...ele,
        price: Number(ele?.price),
      };

      // Remove unnecessary fields
      [
        "id",
        "survey_id",
        "service_name",
        "is_accepted",
        "created_at",
        "updated_at",
      ].forEach((key) => delete service[key]);

      // Conditionally add fields only if they have valid values
      if (ele?.driverQty == null || ele?.driverQty === 0)
        delete service.driverQty;
      if (ele?.porterQty == null || ele?.porterQty === 0)
        delete service.porterQty;
      if (ele?.packerQty == null || ele?.packerQty === 0)
        delete service.packerQty;
      if (ele?.vehicleQty == null || ele?.vehicleQty === 0)
        delete service.vehicleQty;
      if (ele?.vehicleTypeId === "" || ele?.vehicleTypeId === null)
        delete service.vehicleTypeId;
      if (ele?.wageCharge === 0) delete service.wageCharge;
      if (ele?.fuelCharge == null || ele?.fuelCharge === 0)
        delete service.fuelCharge;
      // delete service.id;
      // delete service.survey_id;
      // delete service.service_name;
      // delete service.is_accepted;
      // delete service.created_at;
      // delete service.updated_at;

      // Push the cleaned service object to the services array
      services.push(service);
    } else if (
      ele?.description &&
      ele?.price &&
      ele?.type &&
      ele?.driverQty &&
      ele?.porterQty &&
      ele?.packerQty &&
      ele?.vehicleQty &&
      ele?.vehicleTypeId &&
      ele?.wageCharge &&
      ele?.fuelCharge
    ) {
      services.push({
        ...ele,
        type: ele?.type,
        price: Number(ele?.price),
        driverQty: Number(ele?.driverQty),
        porterQty: Number(ele?.porterQty),
        packerQty: Number(ele?.packerQty),
        vehicleQty: Number(ele?.vehicleQty),
        wageCharge: Number(ele?.wageCharge),
        fuelCharge: Number(ele?.fuelCharge),
      });
    }
  });
  body.services = services;

  //  let costs: any = []
  //  body?.costs?.map((ele:any, idx: any) => {
  //   if(
  //     ele?.driverQty && ele?.porterQty && ele?.packerQty && ele?.vehicleQty &&
  //     ele?.vehicleTypeId && ele?.wageCharge && ele?.fuelCharge
  //   ){
  //     costs.push({
  //       ...ele,
  //       driverQty: Number(ele?.driverQty),
  //       porterQty: Number(ele?.porterQty),
  //       packerQty: Number(ele?.packerQty),
  //       vehicleQty: Number(ele?.vehicleQty),
  //       wageCharge: Number(ele?.wageCharge),
  //       fuelCharge: Number(ele?.fuelCharge)
  //     })
  //   }
  //  })
  //  body.costs = costs

  let materials: any = [];
  body?.materials?.map((ele: any, idx: any) => {
    // if(
    //   ele?.surveyedQty &&
    //   ele?.chargeQty &&
    //   ele?.price &&
    //   ele?.total &&
    //   ele?.volume &&
    //   ele?.cost
    // ){
    materials.push({
      ...ele,
      surveyedQty: Number(ele?.surveyedQty),
      chargeQty: Number(ele?.chargeQty),
      price: Number(ele?.price),
      total: Number(ele?.total),
      volume: Number(ele?.volume),
      cost: Number(ele?.cost),
    });
    // }
  });
  body.materials = materials;

  // let ancillaries: any = [];
  // body?.ancillaries?.map((ele: any, idx: any) => {
  //   if (ele?.name) {
  //     ancillaries.push({
  //       ...ele,
  //       charge: Number(ele?.charge),
  //     });
  //   }
  // });
  // body.ancillaries = ancillaries;

  if (body?.generalInfo) {
    // Ensure generalInfo remains an object, not an array
    if (
      typeof body?.generalInfo === "object" &&
      !Array.isArray(body.generalInfo)
    ) {
      body.generalInfo = {
        ...body.generalInfo,
        porterWage: body.generalInfo?.porterWage
          ? Number(body.generalInfo.porterWage)
          : null,
        packerWage: body.generalInfo?.packerWage
          ? Number(body.generalInfo.packerWage)
          : null,
        driverWage: body.generalInfo?.driverWage
          ? Number(body.generalInfo.driverWage)
          : null,
        contentsValue: body.generalInfo?.contentsValue
          ? Number(body.generalInfo.contentsValue)
          : null,
      };
    } else {
      body.generalInfo = {}; // Default to an empty object if generalInfo is missing or an array
    }
  }

  // Convert insurancePercentage to a number if it's a string
  if (typeof body.insurancePercentage === "string") {
    body.insurancePercentage = parseFloat(body.insurancePercentage);
  }

  // Convert insuranceAmount to a number if it's a string
  if (typeof body.insuranceAmount === "string") {
    body.insuranceAmount = parseFloat(body.insuranceAmount);
  }

  // Convert contentValue to a number if it's a string
  if (typeof body.contentValue === "string") {
    body.contentValue = parseFloat(body.contentValue);
  }

  //  const {
  //   packingOn,
  //   ...newPayload
  // } = payload?.payload;
  try {
    const apiResponse = yield call<any>(
      callAPI,
      { payload: body },
      "post",
      `leads/${generatedId}/${
        screenType === "quotation" ? "quotes" : "estimates"
      }`,
    );

    if (apiResponse?.success === true) {
      apiResponse && handleSuccess(apiResponse);
      yield put(setUpdateLeadAction(true));
      yield put(setUpdateLeadEstimateResponse(true));
      yield put(
        getLeadEstimateAction({ generatedId: generatedId, screenType }),
      );
    }
  } catch (error: any) {
    error?.response && handleError(error?.response);
    error?.code === "ERR_NETWORK" && handleError(error);
    yield put(setAddNewLeadAction(false));
    //   yield put(setAdminErrorAction(true));
  }
  yield put(setLoaderAction(false));
}

function* addLeadQuoteSaga(payload: { payload: any }): any {
  yield put(setLoaderAction(true));
  yield put(setNotificationAction({ message: [], severity: "error" }));
  // Destructure the payload to exclude the `packingOn` field
  console.log("addLeadQuoteSaga payload", payload);
  const { generatedId, screenType } = payload?.payload;
  const {
    leadId,
    createdAt,
    count,
    estimateId,
    requirements,
    undefined,
    hidequotetotal,
    isaccepted,
    created_at,
    updated_at,
    isDeletable,
    hasFinalInvoice,
    is_reaccept_required,
    hasRemovalOrDoorToDoor,
    ...body
  } = payload?.payload?.body;

  // Set quoteExpiresOn conditionally
  body.quoteExpiresOn = screenType === "quotation" ? body.quoteExpiresOn : "";

  let services: any = [];
  if (Array.isArray(body?.services)) {
    body.services.forEach((ele: any) => {
      // Convert vehicles[].fuelCharge and vehicles[].vehicleQty to numbers if present
      let vehicles = ele.vehicles;
      if (Array.isArray(vehicles)) {
        vehicles = vehicles.map((v) => ({
          ...v,
          fuelCharge:
            v.fuelCharge !== null &&
            v.fuelCharge !== undefined &&
            v.fuelCharge !== ""
              ? Number(v.fuelCharge)
              : null,
          vehicleQty:
            v.vehicleQty !== null &&
            v.vehicleQty !== undefined &&
            v.vehicleQty !== ""
              ? Number(v.vehicleQty)
              : null,
        }));
      }
      const service = {
        ...ele,
        price: Number(ele?.price),
        vehicles,
      };
      // Remove unnecessary fields
      [
        "id",
        "survey_id",
        "service_name",
        "is_accepted",
        "created_at",
        "updated_at",
      ].forEach((key) => delete service[key]);
      // Conditionally add fields only if they have valid values
      if (service?.driverQty == null) delete service.driverQty;
      if (service?.porterQty == null) delete service.porterQty;
      if (service?.packerQty == null) delete service.packerQty;
      if (service?.wageCharge == null) delete service.wageCharge;
      services.push(service);
    });
  }
  body.services = services;

  //  let costs: any = []
  //  body?.costs?.map((ele:any, idx: any) => {
  //   if(
  //     ele?.driverQty && ele?.porterQty && ele?.packerQty && ele?.vehicleQty &&
  //     ele?.vehicleTypeId && ele?.wageCharge && ele?.fuelCharge
  //   ){
  //     costs.push({
  //       ...ele,
  //       driverQty: Number(ele?.driverQty),
  //       porterQty: Number(ele?.porterQty),
  //       packerQty: Number(ele?.packerQty),
  //       vehicleQty: Number(ele?.vehicleQty),
  //       wageCharge: Number(ele?.wageCharge),
  //       fuelCharge: Number(ele?.fuelCharge)
  //     })
  //   }
  //  })
  //  body.costs = costs

  let materials: any = [];
  body?.materials?.map((ele: any, idx: any) => {
    // if(
    //   ele?.surveyedQty &&
    //   ele?.chargeQty &&
    //   ele?.price &&
    //   ele?.total &&
    //   ele?.volume &&
    //   ele?.cost
    // ){
    materials.push({
      ...ele,
      surveyedQty: Number(ele?.surveyedQty),
      chargeQty: Number(ele?.chargeQty),
      price: Number(ele?.price),
      total: Number(ele?.total),
      volume: Number(ele?.volume),
      cost: Number(ele?.cost),
    });
    // }
  });
  body.materials = materials;

  let ancillaries: any = [];
  body?.ancillaries?.map((ele: any, idx: any) => {
    if (ele?.name) {
      ancillaries.push({
        ...ele,
        charge: Number(ele?.charge),
      });
    }
  });
  body.ancillaries = ancillaries;

  let subcontractorCharges: any = [];
  body?.subcontractorCharges?.map((ele: any, idx: any) => {
    if (ele?.subContractorId) {
      subcontractorCharges.push({
        ...ele,
        chargeAmount: Number(ele?.chargeAmount),
      });
    }
  });
  body.subcontractorCharges = subcontractorCharges;

  if (body?.generalInfo) {
    // Ensure generalInfo remains an object, not an array
    if (
      typeof body?.generalInfo === "object" &&
      !Array.isArray(body.generalInfo)
    ) {
      body.generalInfo = {
        ...body.generalInfo,
        porterWage:
          body.generalInfo?.porterWage !== null &&
          body.generalInfo?.porterWage !== undefined
            ? Number(body.generalInfo.porterWage)
            : null,
        packerWage:
          body.generalInfo?.packerWage !== null &&
          body.generalInfo?.packerWage !== undefined
            ? Number(body.generalInfo.packerWage)
            : null,
        driverWage:
          body.generalInfo?.driverWage !== null &&
          body.generalInfo?.driverWage !== undefined
            ? Number(body.generalInfo.driverWage)
            : null,
        contentsValue:
          body.generalInfo?.contentsValue !== null &&
          body.generalInfo?.contentsValue !== undefined
            ? Number(body.generalInfo.contentsValue)
            : null,
      };
    } else {
      body.generalInfo = {}; // Default to an empty object if generalInfo is missing or an array
    }
  }

  // Convert insurancePercentage to a number if it's a string
  if (typeof body.insurancePercentage === "string") {
    body.insurancePercentage = parseFloat(body.insurancePercentage);
  }

  // Convert insuranceAmount to a number if it's a string
  if (typeof body.insuranceAmount === "string") {
    body.insuranceAmount = parseFloat(body.insuranceAmount);
  }

  // Convert contentValue to a number if it's a string
  if (typeof body.contentValue === "string") {
    body.contentValue = parseFloat(body.contentValue);
  }

  //  const {
  //   packingOn,
  //   ...newPayload
  // } = payload?.payload;
  try {
    const apiResponse = yield call<any>(
      callAPI,
      { payload: body },
      "post",
      `leads/${generatedId}/${
        screenType === "quotation" ? "quotes" : "estimates"
      }`,
    );

    if (apiResponse?.success === true) {
      apiResponse && handleSuccess(apiResponse);
      yield put(setUpdateLeadAction(true));
      yield put(setUpdateLeadQuoteResponse(true));
      yield put(
        getLeadEstimateAction({ generatedId: generatedId, screenType }),
      );
    }
  } catch (error: any) {
    error?.response && handleError(error?.response);
    error?.code === "ERR_NETWORK" && handleError(error);
    yield put(setAddNewLeadAction(false));
    yield put(setUpdateLeadQuoteResponse(false));
    //   yield put(setAdminErrorAction(true));
  }
  yield put(setLoaderAction(false));
}

function* getLeadEstimateSaga(payload: { payload: any }): any {
  yield put(setLoaderAction(true));
  yield put(setLeadEstimateAction(null));
  // new quote saga addition
  yield put(setLeadQuoteAction(null));
  yield put(setNotificationAction({ message: [], severity: "error" }));
  try {
    const { generatedId, screenType } = payload?.payload;
    const apiResponse = yield call<any>(
      callAPI,
      null,
      "get",
      `leads/${generatedId}/${
        screenType === "quotation" ? "quotes" : "estimates"
      }`,
    );

    if (apiResponse?.success === true) {
      console.log("getLeadEstimateSaga apiResponse", apiResponse);
      // apiResponse && handleSuccess(apiResponse);
      if (screenType === "quotation") {
        const estimatePayload = JSON.parse(JSON.stringify(apiResponse?.data));
        const quotePayload = JSON.parse(JSON.stringify(apiResponse?.data));
        const defaultServiceList = yield select(
          (state: any) => state?.review?.defaultServiceList || [],
        );
        yield put(setLeadEstimateAction(estimatePayload));
        yield put(
          setLeadQuoteAction({
            ...quotePayload,
            defaultServiceList,
          }),
        );
      } else {
        yield put(
          setLeadEstimateAction(JSON.parse(JSON.stringify(apiResponse?.data))),
        );
      }
      yield put(setSingleLeadEstimateAction(true));
    }
  } catch (error: any) {
    error?.response && handleError(error?.response);
    error?.code === "ERR_NETWORK" && handleError(error);
    yield put(setAddNewLeadAction(false));
    yield put(setSingleLeadEstimateAction(false));
    //   yield put(setAdminErrorAction(true));
  }
  yield put(setLoaderAction(false));
}

function* getLeadEstimateLinkSaga({ payload }: { payload: any }) {
  yield put(setLoaderAction(true));
  yield put(setNotificationAction({ message: [], severity: "error" }));

  try {
    const { leadId, estimateId, type, screenType } = payload;
    let url = "";

    if (type === "previous") {
      url = `leads/${leadId}/previous-quotes`;
    } else {
      url = `leads/${leadId}/${
        screenType === "quotation" ? "quote-send-email" : "estimate-send-email"
      }/${estimateId}?action=${type}`;
    }

    // 👉 RUN LOADER STEPS WHILE API IS IN PROGRESS
    const { apiResponse } = yield race({
      apiResponse: call(callAPI, null, "get", url),
      loaderSteps: call(runLoaderSteps, type),
    });

    // 🛑 STOP LOADER STEPS IMMEDIATELY WHEN API IS DONE
    yield put(setLoaderMessage(""));

    if (apiResponse?.success) {
      if (type === "email") {
        handleSuccess(apiResponse);
        store.dispatch(setLeadEstimateDownloaded(true));
        if (screenType === "quotation") {
          yield put(
            getLeadEstimateAction({
              generatedId: leadId,
              screenType: screenType,
            }),
          );
        }
      } else {
        const fileUrl = apiResponse?.data?.pdfUrl;
        let fileUrlData = fileUrl.split("?")[0].split("/");

        new JsFileDownloader({
          url: fileUrl,
          filename: `${
            type === "previous"
              ? "Quote_previous.pdf"
              : // ? fileUrlData[fileUrlData.length - 1]
                fileUrlData[fileUrlData.length - 1]
          }`,
        })
          .then(() => {
            handleSuccess(apiResponse);
            store.dispatch(setLeadEstimateDownloaded(true));
            store.dispatch(setLoaderAction(false));
          })
          .catch((e) => {});
      }
    }
  } catch (error: any) {
    handleError(error?.response || error);
    yield put(setAddNewLeadAction(false));
    yield put(setLoaderMessage(""));
  }

  yield put(setLoaderAction(false));
}

// 👉 separate saga only for loader animation
function* runLoaderSteps(type: any) {
  if (!["email", "pdf", "odt", "previous"].includes(type)) return;

  yield put(setLoaderMessage("Validating confirmation data..."));
  yield delay(3000);

  yield put(setLoaderMessage("Generating ODT template..."));
  yield delay(2000);

  yield put(setLoaderMessage("Converting to PDF..."));
  yield delay(8000);

  yield put(setLoaderMessage("Uploading to secure storage..."));
  yield delay(2000);
}

function* deleteLeadAddressSaga(payload: { payload: any }): any {
  yield put(setLoaderAction(true));
  yield put(setNotificationAction({ message: [], severity: "error" }));
  try {
    const { leadId, addressId } = payload?.payload;
    const apiResponse = yield call<any>(
      callAPI,
      null,
      "delete",
      `leads/${leadId}/addresses/${addressId}`,
    );

    if (apiResponse?.success === true) {
      apiResponse && handleSuccess(apiResponse);
      yield put(setUpdateLeadAction(true));
      yield put(setLeadAddressDeletedAction(true));
    }
  } catch (error: any) {
    error?.response && handleError(error?.response);
    error?.code === "ERR_NETWORK" && handleError(error);
    yield put(setAddNewLeadAction(false));
  }
  yield put(setLoaderAction(false));
}

function* deleteSingleLeadQuoteSaga(payload: { payload: any }): any {
  yield put(setLoaderAction(true));
  yield put(setNotificationAction({ message: [], severity: "error" }));
  try {
    const { leadId, quoteId, screenType } = payload?.payload;
    const apiResponse = yield call<any>(
      callAPI,
      null,
      "delete",
      `leads/${leadId}/${
        screenType === "quotation" ? "quotes" : "estimates"
      }/${quoteId}`,
    );
    if (apiResponse?.success === true) {
      apiResponse && handleSuccess(apiResponse);
      yield put(setUpdateLeadAction(true));
      yield put(
        getLeadEstimateAction({ generatedId: leadId, screenType: screenType }),
      );
      yield put(setDeleteSingleLeadQuoteAction(true));
    }
  } catch (error: any) {
    error?.response && handleError(error?.response);
    error?.code === "ERR_NETWORK" && handleError(error);
    yield put(setAddNewLeadAction(false));
    yield put(setDeleteSingleLeadQuoteAction(false));
  }
  yield put(setLoaderAction(false));
}

// lead customers
function* getLeadCustomerSaga(action: any): any {
  const { name, phone, email, orderIn } = action.payload;
  yield put(setLoaderAction(true));

  try {
    const res = yield call<any>(
      callAPI,
      {},
      "get",
      `leads/customers/search?name=${name}&phon=${phone}&email=${email}`,
    );

    if (res?.data) {
      yield put(setLeadCustomerResponse(res?.data));
    }
  } catch (error: any) {
    console.log("Catch Error-", error);
    // error?.response && handleError(error?.response?.data)
  }
  yield put(setLoaderAction(false));
}

// account name list
function* getAccountNameListSaga(): any {
  yield put(setLoaderAction(true));
  try {
    const res = yield call<any>(
      callAPI,
      {},
      "get",
      `/leads/customers/account-names`,
    );

    if (res?.data) {
      yield put(setAccountNameListAction(res?.data));
    }
  } catch (error: any) {
    console.log("Catch Error-", error);
    // error?.response && handleError(error?.response?.data)
  }
  yield put(setLoaderAction(false));
}

function* getPreviousQuoteSaga(payload: { payload: any }): any {
  yield put(setLoaderAction(true));
  yield put(setNotificationAction({ message: [], severity: "error" }));
  try {
    const { leadId } = payload?.payload;
    const res = yield call<any>(callAPI, {}, "get", `/leads/${leadId}/quotes?is_deleted=true`);

    if (res?.data) {
      yield put(setPreviousQuoteAction(res?.data));
    }
  } catch (error: any) {
    console.log("Catch Error-", error);
    // error?.response && handleError(error?.response?.data)
  }
  yield put(setLoaderAction(false));
}

export function* watchLead() {
  yield takeLatest<any>(getAllLeadListAction, getAllLeadSaga);
  yield takeLatest<any>(getAllReferrerListAction, getAllReferrerListSaga);
  yield takeLatest<any>(getSingleLeadAction, getSingleLeadSaga);
  yield takeLatest<any>(addNewLeadAction, addNewLeadSaga);
  yield takeLatest<any>(addLeadLogAction, addLeadLogSaga);
  yield takeLatest<any>(getAllLeadLogListAction, getAllLeadLogListSaga);
  yield takeLatest<any>(updateLeadAction, updateLeadSaga);
  yield takeLatest<any>(addLeadEstimateAction, addLeadEstimateSaga);
  yield takeLatest<any>(addLeadQuoteAction, addLeadQuoteSaga);
  yield takeLatest<any>(getLeadEstimateAction, getLeadEstimateSaga);
  yield takeLatest<any>(getLeadEstimateLinkAction, getLeadEstimateLinkSaga);
  yield takeLatest<any>(getCalculateDistanceAction, getCalculateDistanceSaga);
  yield takeLatest<any>(deleteLeadAddressAction, deleteLeadAddressSaga);
  yield takeLatest<any>(deleteSingleLeadQuoteAction, deleteSingleLeadQuoteSaga);
  yield takeLatest<any>(getLeadCustomerAction, getLeadCustomerSaga);
  yield takeLatest<any>(getAccountNameListAction, getAccountNameListSaga);
  yield takeLatest<any>(getPreviousQuoteAction, getPreviousQuoteSaga);
}
